var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",on:{"touchmove":function($event){$event.stopPropagation();}}},[_vm._t("default"),(_vm.showClose)?_c('div',{staticClass:"ico-close",on:{"click":_vm.close}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }